
var cache = {categories: {}, dataReady: undefined};
function prepareCache (instance) {
	if (cache.dataReady === undefined) {
		cache.dataReady = false;
		instance.$http.get('backend://category').then(function (result) {
			var newCategories = {};
			for (var i = 0; i < result.body.items.length; i++) {
				var item = result.body.items[i];
				newCategories[item.id] = item;
			}
			cache.categories = newCategories;
			cache.dataReady = true;
		});
	}
}
function updateCache (instance) {
	cache.dataReady = undefined;
	prepareCache(instance);
}

module.exports = {
	data: cache,
	prepare: prepareCache,
	update: updateCache
};



// WEBPACK FOOTER //
// ./src/components/base/category/category-cache.js